import type { EqualityFn, SelectorFn } from '@studio/react-utils/store';
import { useContext } from 'react';
import { Context } from './context.js';
import type { Producer, State } from './types.js';

/**
 * Returns the store producer.
 *
 * @returns Producer.
 */
export const useProducer = (): Producer => useStore((µ) => µ.produce);

/**
 * Returns a reactive slice of the store.
 *
 * @param selectorFn - Slice selector.
 * @param equalityFn - Slice equality function.
 * @returns Selected slice.
 */
export function useStore<Slice>(
  selectorFn: SelectorFn<State, Slice>,
  equalityFn?: EqualityFn<Slice>
): Slice {
  return useContext(Context)?.(selectorFn, equalityFn) ?? ({} as Slice);
}
